import { Injectable } from '@angular/core';
// import { Socket } from 'ngx-socket-io';
import {Observable, of} from "rxjs";
import {User} from "../_models/User";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class TokenStorage {

    private endpoint = environment.endpoint;

    constructor(
        // private socketService: Socket,
                private http: HttpClient) {
    }

    /**
     * Set access token
     * @returns {TokenStorage}
     */
    public setAccessToken(token: string): TokenStorage {
        localStorage.setItem('authentication-token', token);
        return this;
    }


    /**
     * Set token details
     * @returns {TokenStorage}
     */
    public setTokenDetails(data: any): TokenStorage {
        localStorage.setItem('session_details', data);
        return this;
    }



    /**
     * Get token details
     * @returns {Observable<string>}
     */
    public getTokenDetails(): Observable<string> {
        const token: string = <string>localStorage.getItem('session_details');

        return of(token);
    }



    public sendTokenToSocketIo() {
        const token: string = <string>localStorage.getItem('authentication-token');
        // this.socketService.emit('subscribe-to-channel', { channel: token });
        return this;
    }
    /**
     * Get access token
     * @returns {Observable<string>}
     */
    public getAccessToken(): Observable<string> {
        const token: string = <string>localStorage.getItem('authentication-token');

        return of(token);
    }

    /**
     * Set logged user
     * @returns {TokenStorage}
     */
    public setLoggedUser(user: any): TokenStorage {
        localStorage.setItem('user', JSON.stringify(user));
        return this;
    }

    /**
     * Get logged user
     * @returns {Observable<string>}
     */
    public getLoggedUser(): Observable<User> {
        const user: User = <User>JSON.parse(<string>localStorage.getItem('user'));
        return of(user);
    }

    /**
     * Get user details
     * @returns {Observable<string>}
     */
    public getUserDetails() {
        return JSON.parse(<string>localStorage.getItem('user'));

    }


    /**
     * Set refresh token
     * @returns {TokenStorage}
     */
    public setRefreshToken(token: string): TokenStorage {
        localStorage.setItem('refreshToken', token);

        return this;
    }

    /**
     * Get refresh token
     * @returns {Observable<string>}
     */
    public getRefreshToken(): Observable<string> {
        const token: string = <string>localStorage.getItem('refreshToken');
        return of(token);
    }

    /**
     * Remove tokens
     */
    public clear() {
        localStorage.removeItem('authentication-token');
        localStorage.removeItem('user');
        localStorage.removeItem('session_details');

    }







}
